import api from './api';

export const getCopaymentLogs = async (filters = {}) => {
    const params = Object.fromEntries(
        Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    );
    const response = await api.get('/admin/copayment/logs', { params });
    return response.data;
};

export const getErrorIncidents = async (filters = {}) => {
    const params = Object.fromEntries(
        Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    );
    const response = await api.get('/admin/error-incidents', { params });
    return response.data;
};

export const updateErrorIncidentStatus = async (id, status) => {
    const response = await api.patch(`/admin/error-incidents/${id}`, { status });
    return response.data;
};
